import { render, staticRenderFns } from "./addmess.vue?vue&type=template&id=481c5d80&scoped=true"
import script from "./addmess.vue?vue&type=script&lang=js"
export * from "./addmess.vue?vue&type=script&lang=js"
import style0 from "./addmess.vue?vue&type=style&index=0&id=481c5d80&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c5d80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('481c5d80')) {
      api.createRecord('481c5d80', component.options)
    } else {
      api.reload('481c5d80', component.options)
    }
    module.hot.accept("./addmess.vue?vue&type=template&id=481c5d80&scoped=true", function () {
      api.rerender('481c5d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parts/addmess.vue"
export default component.exports